/**
 * Admin Dashboard v2 — /admin/dashboard (route shell).
 *
 * FE-5: the heavy dashboard component (hero band + 3-column operational grid,
 * ~850 lines) is split into `./dashboard-screen.tsx` and lazy-loaded so it
 * lands in its own chunk instead of the entry bundle. Mirrors the existing
 * route-shell pattern (see ./dsar.tsx → ./dsar-screen.tsx).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/dashboard')({
  component: lazyRouteComponent(() => import('./dashboard-screen'), 'DashboardBoard'),
});
